module.exports = __webpack_public_path__ + "static/media/in-hand-funds.2785250d.svg";